export const getFormattedUrl = (format: string, downloadUrl?: string) => {
  if (!downloadUrl) return '';
  const extension = `.${downloadUrl?.substring(
    downloadUrl.lastIndexOf('.') + 1
  )}`;

  let url = '';
  switch (format) {
    case 'webm':
      url = downloadUrl.replace(extension, `_optimized.webm`);
      break;
    case 'web':
      url = downloadUrl.replace(extension, `_optimized${extension}`);
      break;
    case 'high':
      url = downloadUrl.replace(extension, `_original${extension}`);
      break;
    case 'png':
      url = downloadUrl.replace(extension, '_thumbnail.png');
      break;
    default:
      break;
  }
  return url;
};

export const downloadOptions = [
  { text: 'Download webm', type: 'webm' },
  { text: 'Download web optimized mp4', type: 'web' },
  { text: 'Download high resolution mp4', type: 'high' },
  { text: 'Download thumbnail', type: 'png' },
];
